const setting = {
  passwordTitle: "Password",
  changePasswordBtn: "Cambiare la password",
  changePasswordTips:
    "Se dimentichi la password o vuoi cambiarla, puoi farlo qui; invieremo un codice di verifica al tuo indirizzo e-mail registrato, che deve essere verificato per confermare la tua identità, dopodiché potrai reimpostare la password del tuo account.",
  feedbackTitle: "Feedback",
  feedbackBtn: "Invia feedback",
  feedbackTips:
    "Per consentirci di servirti meglio, puoi descrivere il tuo problema qui e inviarcelo per un feedback e il nostro team di assistenza clienti ti contatterà il prima possibile.",
  appearanceTitle: "Visualizzazione dell'aspetto",
  appearanceBtn: "Cambia visualizzazione",
  appearanceTips: "Scegliamo due modalità di aspetto per te, così puoi passare dalla modalità scura a quella chiara in base alle tue preferenze.",
  changePassWordModalTitle: "Cambiare la password",
  changePassWordSameErrorTips: "La nuova password che hai inserito è la stessa della tua vecchia password. Inserisci una password diversa",
  changePasswordCurrentErrorTips: "La tua password è sbagliata. Per favore riprova.",
  currentPasswordLabel: "Password attuale",
  newPasswordLabel: "Nuova password",
  retypePasswordLabel: "Ridigita la nuova password",
  changePasswordSuccessTips: "La tua password è stata cambiata con successo.",
  changePasswordComfirmDiffErrorTips: "Si prega di inserire la stessa password in entrambi i campi.",
  forgotPassword: "Ha dimenticato la password?",
  feedbackModalSubtitle: "Grazie per averci contattato e averci detto la tua opinione sul prodotto!",
  feedBackModalProductQuestion: "Che tipo di problemi vuoi risolvere con il nostro prodotto",
  feedBackModalProductTypeSug: "Suggerimenti",
  feedBackModalProductTypeMem: "Domande relative al servizio per i membri",
  feedBackModalProductTypeFun: "Richiesta di funzione",
  feedBackModalProductTypeReq: "Requisiti del prodotto",
  feedBackModalProductTypeBug: "Feedback sui bug del prodotto",
  feedBackModalProductTypeIss: "Problemi di prestazione",
  feedBackModalProductTypeRL: "Domande relative alla registrazione e al login",
  feedBackModalProductTypeRef: "Servizio di rimborso",
  feedBackModalProductTypeOth: "Altri",
  feedBackModalProductSelectQuestion: "Che tipo di problemi vuoi risolvere con il nostro prodotto",
  feedBackModalProductContQuestion: "Qual è il problema riscontrato durante l'utilizzo del prodotto?",
  feedBackModalAddImageBtn: "Aggiungi immagini",
  feedBackModalTips: "Suggerimenti:",
  feedBackModalTipsCont: "A causa della differenza di fuso orario del servizio clienti globale, ti risponderemo entro 48 ore dal giorno lavorativo;",
  feedBackSuccessTips: "Invia con successo",
  feedBackSuccessSubTips: "Risolveremo il tuo problema al più presto",
  feedBackFailedTips: "Invio non riuscito",
  feedBackFailedSubTips: "Assicurati che la tua connessione di rete funzioni e invia di nuovo",
  appearanceLightMode: "Modalità di colore chiaro",
  appearanceDarkMode: "Modalità di colore scuro",
  promotionModalTitle: "Promozione",
  promoItem: "Categoria di offerta",
  promoCode: "Codice promozionale",
  discount: "Sconto",
  applyBtn: "Applicare",
  applyPromotionErrorTips: "Il tuo codice promozionale non è valido",
};

export default setting;
